import { locations as mockData } from './mock/oe-select-location.mock'

function addValidationProperties() {
  const obj = {}
  obj.foo = ''
  return obj
}

export function openEnrollmentSelectLocationFactory(response) {
  if (process.env.VUE_APP_OE_MOCK_DATA === 'true') {
    mockData.validation = addValidationProperties()
    return mockData
  } else {
    if (response) {
      const locations = []
      response.forEach((location) => {
        const requestLocation = {
          eventRequestId: location.eventRequestId ? location.eventRequestId : '',
          locationId: location.eventLocationId ? location.eventLocationId : location.locationId ? location.locationId : '',
          locationName: location.locationName,
          name: location.locationName,
          requestBenefitInd: location.requestBenefitInd,
          requestDigitalInd: location.requestDigitalInd,
          requestMaterialsInd: location.requestMaterialsInd,
          requestStandardInd: location.requestStandardInd,
          eventType: location.eventType,
          eventDate: '',
          requestStatus: location.requestStatus,
          needByDate: location.shipDeliverDate,
          packets: '',
          spanish: '',
          raffle: '',
          address: '',
          eligible: location.employeeQuantity,
          eligibleEmployees: location.employeeQuantity,
          multilingualIndicator: location.multilingualIndicator ? location.multilingualIndicator : 'N',
          requesterName: location.requestedBy,
          contactInformation: {
            name: location.contactName ? location.contactName : location.contactInformation ? location.contactInformation.name : '',
            email: location.contactEmail ? location.contactEmail : location.contactInformation ? location.contactInformation.email : '',
            phone: location.contactPhone ? location.contactPhone : location.contactInformation ? location.contactInformation.phone : '',
            phoneExt: location.contactExt ? location.contactExt : location.contactInformation ? location.contactInformation.phoneExt : ''
          },
          location: {
            addressLine1: location.locationAddress ? location.locationAddress.addressLine1 : '',
            addressLine2: location.locationAddress ? location.locationAddress.addressLine2 : '',
            city: location.locationAddress ? location.locationAddress.city : '',
            state: location.locationAddress ? location.locationAddress.stateCode : '',
            zipCode: location.locationAddress ? location.locationAddress.postalCode : ''
          }
        }
        locations.push(requestLocation)
      })
      return locations
    }
  }
}
